import { render, staticRenderFns } from "./MessageWidgetEmail.vue?vue&type=template&id=31ebec7f&"
import script from "./MessageWidgetEmail.vue?vue&type=script&lang=js&"
export * from "./MessageWidgetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports